import PropTypes from 'prop-types'
import React from 'react'

import styles from './email-input-element.scss'

export default class EmailInputElement extends React.Component {
  render () {
    const {
      useMaskedEmail,
      setUseMaskedEmailFalse,
      maskedEmailAddress,
      value,
      ...otherProps
    } = this.props
    let inputValue = value === '' ? null : value
    if (useMaskedEmail) {
      inputValue = maskedEmailAddress
    }

    const changeEmailLink = <a onClick={setUseMaskedEmailFalse}>Change</a>

    return (
      <div className={styles['container']}>
        <input
          type='text'
          placeholder='Email Address'
          autoComplete='off'
          value={inputValue}
          disabled={useMaskedEmail}
          {...otherProps}
        />
        {useMaskedEmail ? changeEmailLink : null}
      </div>
    )
  }
}

EmailInputElement.propTypes = {
  maskedEmailAddress: PropTypes.string,
  useMaskedEmail: PropTypes.bool,
  setUseMaskedEmailFalse: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/components/forms/EmailInputElement.jsx